@if (loaderFull.loading$ | async) {
  <div class="loader-full" (click)="$event.stopPropagation()">
    <div class="center">
      <div class="logo">
        <img width="128" src="assets/icons/logos/logo.svg" alt="logo" />
      </div>

      <!-- Material Design Spinner -->
      <div class="spinner-wrapper">
        <div class="spinner">
          <div class="inner">
            <div class="gap"></div>
            <div class="left">
              <div class="half-circle"></div>
            </div>
            <div class="right">
              <div class="half-circle"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- / Material Design Spinner -->
      <p class="loader-text">
        {{ 'PLEASE_WAIT' | translate }}
        <span [class.hidden]="!loaderFull.isPleaseWaite1"
          ><br />{{ 'PLEASE_WAIT_1' | translate }}</span
        >
        <span [class.hidden]="!loaderFull.isPleaseWaite2"> {{ 'PLEASE_WAIT_2' | translate }}</span>
        <span [class.hidden]="!loaderFull.isPleaseWaite3"> {{ 'PLEASE_WAIT_3' | translate }}</span>
      </p>
    </div>
  </div>
}
